












































































import Vue from 'vue'
import { mapActions } from 'vuex'
import TinyMceEditor from '@tinymce/tinymce-vue'

import Artifacts from '@/components/artifacts/Artifacts.tsx'
import Editor from '@/components/artifacts/NewEditor'

const filters = {
  '#de': { language_code: 'de' },
  '#ar': { language_code: 'ar' },
  '#en': { language_code: 'en' },
  '#ipt': { treatment_code: 'ipt' },
  '#cbt': { treatment_code: 'cbt' },
  '#expo': { treatment_code: 'expo' },
  '#cr': { treatment_code: 'cr' },
  '#counselling': { treatment_code: 'counselling' },
  '#letter': { type: 'letter' },
  '#mail': { type: 'mail' },
  '#message': { type: 'message' },
  '#female-author': { gender_of_writer: 'female' },
  '#male-author': { gender_of_writer: 'male' },
  '#female-reader': { gender_of_reader: 'female' },
  '#male-reader': { gender_of_reader: 'male' },
}

export default Vue.extend({
  components: { Artifacts, Editor, TinyMceEditor },
  computed: {
    templates(): any[] {
      return this.$store.getters['letterTemplates/storedObjectsArray'].filter((t: any) => {
        const selected = this.selected
        return (
          selected.language.indexOf(t.language_code) >= 0 &&
          selected.treatment.indexOf(t.treatment_code) >= 0 &&
          selected.reader.indexOf(t.gender_of_reader) >= 0 &&
          selected.writer.indexOf(t.gender_of_writer) >= 0 &&
          selected.type.indexOf(t.type) >= 0
        )
      })
    },
    selectedTemplate(): any {
      const activeTemplateId = this.activeTemplateId
      return activeTemplateId
        ? this.$store.getters['letterTemplates/storedObjects'][activeTemplateId]
        : {}
    },
    tags(): string[] {
      return (
        this.tagline.match(
          /#(de|ar|en|(female|male)-(author|reader)|ipt|cbt|cr|expo|counselling|letter|mail|message)/g
        ) || ([] as string[])
      )
    },
    filters(): any {
      return this.tags.map(t => filters[t]).reduce((acc, now) => ({ ...acc, ...now }), {})
    },
  },
  data() {
    return {
      tagline: '',
      activeTemplateId: null,
      options: {
        type: [
          { value: 'letter', text: 'Brief' },
          { value: 'message', text: 'System-Nachricht' },
          { value: 'mail', text: 'E-Mail' },
        ],
        treatment: [
          { value: 'ipt', text: 'IPT' },
          { value: 'cbt', text: 'CBT' },
          { value: 'cr', text: 'CR' },
          { value: 'expo', text: 'Exposition' },
          { value: 'counseling', text: 'Counseling' },
        ],
        reader: [{ value: 'female', text: 'weiblich' }, { value: 'male', text: 'männlich' }],
        writer: [{ value: 'female', text: 'weiblich' }, { value: 'male', text: 'männlich' }],
        language: [
          { value: 'en', text: 'Englisch' },
          { value: 'de', text: 'Deutsch' },
          { value: 'ar', text: 'Arabisch' },
        ],
      },
      selected: {
        treatment: ['ipt'],
        reader: ['female'],
        writer: ['female'],
        language: ['ar'],
        type: ['letter'],
      },
      gender: [
        { value: null, text: 'für beide' },
        { value: 'female', text: 'falls weiblich' },
        { value: 'male', text: 'falls männlich' },
      ],
      types: [
        { value: null, text: 'nicht spezifiziert' },
        { value: 'letter', text: 'Brief' },
        { value: 'message', text: 'System-Nachricht' },
        { value: 'mail', text: 'E-Mail' },
      ],
      language: [
        { value: null, text: 'für alle' },
        { value: 'en_CA', text: 'Englisch' },
        { value: 'de', text: 'Deutsch' },
        { value: 'ar', text: 'Arabisch' },
      ],
      treatment: [
        { value: null, text: 'für alle' },
        { value: 'ipt', text: 'IPT' },
        { value: 'cbt', text: 'CBT' },
        { value: 'cr', text: 'CR' },
        { value: 'expo', text: 'Exposition' },
        { value: 'counseling', text: 'Counseling' },
      ],
    }
  },
  methods: {
    ...mapActions('letterTemplates', ['pushObject', 'dropObject']),
    directionality(template: any) {
      return template.language_code === 'ar' ? 'rtl' : 'ltr'
    },
    drop() {
      if (
        window.confirm(
          (this.$t('letterTemplates.confirmDeletion') as string) || 'Wirklich löschen?'
        )
      ) {
        this.$store
          .dispatch({
            type: 'letterTemplates/dropObject',
            object: this.selectedTemplate,
          })
          .then(() => {
            this.activeTemplateId = null
            ;(this.$refs.editor as any).reset()
          })
      }
    },
    reset() {
      if (
        window.confirm(
          (this.$t('letterTemplates.confirmReset') as string) || 'Wirklich zurücksetzen?'
        )
      ) {
        ;(this.$refs.editor as any).reset()
      }
    },
    isMatch(t: any): boolean {
      const selected = this.selected
      const result: boolean =
        (t.language_code === null || selected.language.indexOf(t.language_code)) >= 0 &&
        (t.treatment_code === null || selected.treatment.indexOf(t.treatment_code)) >= 0 &&
        (t.gender_of_reader === null || selected.reader.indexOf(t.gender_of_reader)) >= 0 &&
        (t.gender_of_writer === null || selected.writer.indexOf(t.gender_of_writer)) >= 0 &&
        (t.type === null || selected.type.indexOf(t.type)) >= 0
      return result
    },
    selectTemplate(template: any) {
      const editor: any = this.$refs.editor
      if (!editor) {
        return
      }
      if (editor.modified) {
        if (
          window.confirm(
            (this.$t('letterTemplates.saveAndContinue') as string) ||
              'Die Änderungen wurden noch nicht gespeichert! Dies noch tun?'
          )
        ) {
          editor.save().then(() => {
            editor.reset()
            this.activeTemplateId = template.id
          })
        }
      } else {
        this.activeTemplateId = template.id
      }
    },
  },
})
